import { competitiveIntelligenceResearchTranslations } from './competitive-intelligence-research'
import { analyticsTranslations } from './analytics'

export const static_translation = {
  ...analyticsTranslations.Japanese,
    "audience_access_available_audiences": "アクセス可能な対象者",
    "audience_access_hcp": "医療従事者が利用可能",
    "audience_access_partner": "パートナーが利用可能",
    "audience_access_staff_us": "米国スタッフが利用可能",
    "audience_access_staff_global": "グローバルスタッフが利用可能",
  "upload_success": "アップロードが正常に送信されました。承認待ちです。",
  "upload_title": "コンテンツアップロードリクエストフォーム",
  "context": 'コンテクスト',
  "mvu_essentials_register_welcome": "Welcome to MagVenture Universe Lite",
  "mvu_essentials_register_access_notice": "Access with this code is limited to a specific number of people. Thank you for not sharing it.",
  "portal_registration_participant_limit_reached": "このアクセスの参加者上限に達したため、登録できません。サポートについては、MagVenture のアクセス担当者にお問い合わせください。",
  "portal_registration_invite_invalid": "この招待リンクは無効か、有効期限が切れています。",
  "lite_registration_success_title": "登録が完了しました",
  "lite_registration_success_email_text": "MagVenture Universe Lite へのアクセス準備が整いました。アクセスリンクを記載したウェルカムメールを送信しました。登録したメールアドレスとパスワードでログインしてください。",
  "lite_registration_success_text": "MagVenture Universe Lite へのアクセス準備が整いました。登録したメールアドレスとパスワードでログインしてください。",
  "lite_registration_success_action": "Lite のログインへ",
  "accelerator_registration_success_title": "登録が完了しました",
  "accelerator_registration_success_email_text": "MagVenture Accelerator Program へのアクセス準備が整いました。アクセスリンクを記載したウェルカムメールを送信しました。登録したメールアドレスとパスワードでログインしてください。",
  "accelerator_registration_success_text": "MagVenture Accelerator Program へのアクセス準備が整いました。登録したメールアドレスとパスワードでログインしてください。",
  "accelerator_registration_success_action": "Accelerator のログインへ",
  "describe_as_upload": "以下の情報を入力し、MagVenture Universe にアップロードする新しいコンテンツとして提案したいファイルをアップロードしてください。数日以内に、サポートチームからご連絡し、ご要望に関する詳細をお知らせいたします。",
  "title": "タイトル",
  "table": "コンテンツタイプ",
  "tags": "タグ",
  "tag-types": "タグタイプ",
  "categories": "カテゴリー",
  "sub-categories": "サブカテゴリー",
  "document": "ドキュメント",
  "image": "画像",

  "cancel": "キャンセル",
  "send": "送信",
  'share_link': 'リンクを共有',
  'share_link_description': 'このリンクを持っている人は、{days}日間このコンテンツにアクセスできます。安全にコピーして共有してください。',
  'share_link_label': 'このリンクを共有：',
  'copy_link': 'リンクをコピー',
  'copied': 'コピーしました！',
  'share_link_warning': 'このリンクは{days}日後に期限切れになります。',
  'share_link_duration': '有効期間（日）',
  'copy': 'コピー',
  "term_title": "クッキーとプライバシーに関する声明",
  "register": "登録",
  "login": "ログイン",
  "email": "メールアドレス",
  "registration_professional_email_hint": "name@yourclinic.com のような職場のメールアドレスをご使用ください。",
  "password": "パスワード",
  "signin": "ログイン",
  "session_expired_sign_in_again": "セッションの有効期限が切れました。続行するには、もう一度サインインしてください。",
  "reset_password": "パスワードをリセット",
  "fill_the_field": "この項目を入力してください",
  "success": "ありがとうございます！",
  "onboarding": "オンボーディング動画",
  "account_successfully_created": "弊社チームがお客様の申請内容を確認し、必要に応じてご連絡いたします。アカウントが承認され、利用可能になりましたらメールでお知らせします。",
  "close": "閉じる",
  "salutation": "敬称",
  "first_name": "名",
  "last_name": "姓",
  "company_name": "会社名",
  "job_title": "役職 / ポジション",
  "industry": "業種",
  "state": "州 / 都道府県",
  "zipcode": "郵便番号",
  "phone_number": "電話番号",
  "password_confirmation": "パスワードの確認",
  "mr": "様（男性）",
  "mrs": "様（既婚女性）",
  "ms": "様（女性）",
  "signup": "アカウントを作成",
  "are_you_a_patient_or_a_therapist": "患者さまですか、それとも治療者ですか？",
  "create_your_password": "パスワードを作成",
  "finish": "完了",
  "create_your_account": "アカウントを作成",
  "back": "戻る",
  "next": "次へ",
  "create_a_password": "パスワードを作成",
  "enter_a_password_for_your_account": "アカウント用のパスワードを入力してください",
  "subscribe_to_newsletter": "はい、MagVenture から教育に関する最新情報、TMS リソース、イベント情報を受け取ります。",
  "subscribe_to_newsletter_information": "いつでも購読を解除できます。お客様のビジネスメールの受信トレイを尊重し、関連性の高いコンテンツのみを配信いたします。",
  "i_accept_the": "次に同意します：",
  "i_accept_the_united": "米国プライバシーポリシー",
  "privacy_policy": "プライバシーポリシー",
  "send": "送信",
  "back_to_login": "ログイン画面に戻る",
  "enter_your_email_to_recover_your_password": "パスワードを再設定するためにメールアドレスを入力してください",
  "access_the_recovery_link_that_was_sent_to_your_email": "メールで送信された再設定リンクにアクセスしてください",
  "check_your_email": "メールをご確認ください",
  "new_password": "新しいパスワード",
  "confirm_new_password": "新しいパスワードの確認",
  "new_password_and_new_password_confirmation_are_not_the_same": "新しいパスワードと確認用パスワードが一致しません",
  "password_changed_successfully": "パスワードが正常に変更されました！",
  "create_a_new_password": "新しいパスワードを作成",
  "enter_a_new_password_for_your_account": "アカウント用の新しいパスワードを入力してください",
  "save": "保存",
  "one_uppercase_letter": "英大文字を1文字以上含めてください",
  "one_number": "数字を1文字以上含めてください",
  "at_least_6_characters": "6文字以上で入力してください",
  "at_least_1_special_character": "記号を1文字以上含めてください",
  "accept_terms": "利用規約に同意する",
  "password_and_password_confirmation_must_match": "パスワードと確認用パスワードが一致している必要があります",
  "see_all": "すべて表示",
  "watch_live_now": "ライブを今すぐ視聴",
  "courses_available_for_you": "ご利用いただけるプログラム",
  "partners-and-staffs_available_for_you": "ご利用いただける Partners and Staff コンテンツ",
  "product-information_available_for_you": "ご利用いただける製品情報",
  "articles_available_for_you": "ご利用いただける記事",
  "podcasts_available_for_you": "ご利用いただけるポッドキャスト",
  "documents_available_for_you": "ご利用いただけるドキュメント",

  "support-materials_available_for_you": "ご利用いただける臨床サポート資料",
  "marketing-materials_available_for_you": "ご利用いただける診療所マーケティング資料",
  "service-supports_available_for_you": "ご利用いただける Service & Support 資料",
  "product-informations_available_for_you": "ご利用いただける診療所向け製品情報",
  "media-templates_available_for_you": "ご利用いただけるSNSテンプレート",
  "videos_available_for_you": "ご利用いただける動画",
  "photos_available_for_you": "ご利用いただける写真",

  "courses": "トレーニングと学習",
  "partners-and-staffs": "Partners and Staff",
  "product-information": "製品情報",
  "articles": "記事",
  "podcasts": "ポッドキャスト",
  "documents": "ドキュメント",
  "home": "ホーム",
  "favorites": "お気に入り",
  "no_favorites_message": "お気に入りはまだありません。",
  "faq": "よくある質問",
  "no_faqs_available": "利用可能なFAQはありません。",
  "support": "サポート",
  "contact_us": "お問い合わせ",
  "my_account": "マイアカウント",
  "my_certificates": "マイ修了証",
  "logout": "ログアウト",
  "search": "検索",
  "frequently_asked_questions": "よくある質問",
  "how_can_we_help_you": "どのようなサポートが必要ですか？",
  "add_new_ticket": "サポート依頼を作成",
  "all_tickets": "すべての依頼",
  "pending": "保留中",
  "closed_tickets": "完了した依頼",
  "videos_and_contents": "動画とコンテンツ",
  "ticket_information": "依頼情報",
  "add_reply": "返信を追加",
  "close_ticket": "依頼を閉じる",
  "status": "ステータス",
  "ticket_id": "依頼ID",
  "created_date": "作成日",
  "category_department": "カテゴリ/部署",
  "give_feedback": "フィードバックを送る",
  "how_would_you_rate_the_way_this_request_was_handled": "この依頼の対応をどのように評価しますか？",
  "subject": "件名",
  "area_departament": "エリア / 部署",
  "message": "メッセージ",
  "create_a_new_ticket": "新しい依頼を作成",
  "describe_as_soon_as_possible": "問題を記載し、適切な部署を選択してください。弊社チームができるだけ早く対応します。",
  "no_records_found": "該当する記録はありません",
  "showing": "表示中",
  "of": "/",
  "results": "件の結果",
  "subject_title": "件名/タイトル",
  "last_updated": "最終更新日",
  "cancel": "キャンセル",
  "registration_data": "登録情報",
  "updated_successfully": "正常に更新されました",
  "created_successfully": "正常に作成されました",
  "edit": "編集",
  "done": "完了",
  "filters": "フィルター",
  "search.sections.trainingLearning": "トレーニングと学習",
  "search.sections.documents": "ドキュメント",
  "search.sections.images": "画像",
  "category": "カテゴリ",
  "filter": "絞り込み",
  "clear": "クリア",
  "support_materials": "臨床サポート資料",
  "marketing_materials": "診療所マーケティング資料",
  "media_templates": "SNSテンプレート",
  "videos": "動画",
  "photos": "写真",
  "support-materials": "臨床サポート資料",
  "marketing-materials": "マーケティング資料",
    "sales-support-materials": "Sales Support Materials",
    "sales-support-materials_available_for_you": "Sales Support Materials available for you",
    "sales_support_materials_empty": "No sales support materials are available yet.",
    "sales_support_materials_error": "We could not load the sales support materials. Please try again.",
    "sales_support_materials_unavailable": "Sales support materials are temporarily unavailable",
  "service-supports": "Service & Support",
  "service_support": "Service & Support",
  "support_videos": "Support Videos",
  "support_videos_empty": "サポート動画はまだありません。",
  "support_videos_unavailable": "サポート動画を利用できません",
  "support_videos_error": "サポート動画を読み込めませんでした。もう一度お試しください。",
  "support_video_unavailable": "サポート動画を利用できません",
  "support_video_media_missing": "動画を利用できません",
  "support_video_media_missing_description": "このサポート動画には、まだ再生可能なメディアがありません。",
  "support_video_about": "この動画について",
  "product-informations": "製品情報",
  "media-templates": "SNSテンプレート",
  "login_title": "ログインしてください",
  "login_title_essentials": "MagVenture Universe Lite にログインしてください",
  "accelerator_brand_name": "MagVenture",
  "accelerator_brand_program": "Accelerator Program",
  "login_title_accelerator": "Welcome to the MagVenture Accelerator Portal",
  "accelerator_welcome_intro": "This is your exclusive portal for everything you need to prepare for and participate in the MagVenture Accelerator.",
  "accelerator_welcome_details": "Here you’ll find clinical training focused specifically on Introduction to TMS, Major Depressive Disorder (MDD), and Obsessive Compulsive Disorder (OCD), along with materials and resources from the Accelerator program which will be posted after the program.",
  "accelerator_welcome_login": "Log in to access your training and Accelerator resources.",
  "welcome": "ようこそ！こちらは、臨床トレーニング、診療所マーケティング素材、動画・治療写真・SNSテンプレートなどのメディアリソースへアクセスするための専用ポータルです。MagVenture での成功を支援するツールにアクセスするにはログインしてください。",
  "existing_users": "既存ユーザー",
  "enter_credentials_to_continue": "ログイン情報を入力して続行してください。",
  "new_users": "新規ユーザー",
  "register_link_text": "登録",
  "register_and_gain_access_part1": "アカウントが必要ですか？ 次へ：",
  "register_and_gain_access_part2": " にアクセスし、当社の専用学習・リソースプラットフォームをフルにご利用ください。",
  "contact": "お問い合わせ",
  "contact.topicCategory": "トピックのカテゴリを選択",
  "contact.topicCategory.label": "トピックカテゴリ",
  "contact.chooseSubject": "ご依頼内容に最も近い件名を選択してください。",
  "contact.message": "メッセージ",
  "contact.message.label": "メッセージ",
  "contact.describeIssue": "問題を詳しくご記入ください。弊社チームができるだけ早くご連絡します。",
  "contact.fileAttachment": "ファイルを添付",
  "contact.fileAttachment.label": "添付ファイル",
  "contact.attachmentHelp": "任意で、依頼内容に関連するスクリーンショットやファイルを添付できます。（例：JPG、PNG、PDF、DOC）",
  "contact.preferredContact": "希望する連絡方法",
  "contact.preferredContact.label": "希望連絡方法",
  "contact.contactPreference": "この問題について、どのような方法での連絡を希望しますか？",
  "contact.maximum_characters": "最大：1000文字",
  "contact.email.label": "メール",
  "contact.phone.label": "電話",
  "contact.technical_support": "MagVenture Universe のコンテンツに関する質問",
  "contact.video_streaming": "動画再生に関する問題",
  "contact.questions_about_products": "MagVenture 製品/サービスに関する質問",
  "contact.material_download": "資料ダウンロードに関する問題",
  "contact.suggestion": "提案",
  "contact.other": "その他",
  "contact.file": "ファイルを選択",
  "contact.submit": "送信",
  "contact.is_required": "は必須です",
  "contact.success": "お問い合わせが正常に送信されました",
  "register.undertems": "MagVenture Universe へのアクセスは審査および承認の対象となります。登録申請の承認には最大2営業日かかる場合があります。",
  "courses-webnars-trainning": "コース、ウェビナー、トレーニング",
  "usshop": "米国ショップ",
  "chat": "チャットエージェント",
  "country": "国",
  "verify_email": "メールアドレスの確認",
  "enter_the_code_sent_to_your_email": "メールで送信されたコードを入力してください",
  "we_sent_a_code_to_email": "次のアドレスに認証コードを送信しました：",
  "enter_verification_code": "認証コードを入力",
  "code_expires_in": "コードの有効期限：",
  "verify": "確認",
  "resend_code_in": "コード再送可能まで：",
  "resend_code": "コードを再送信",
  "a_new_code_has_been_sent": "新しいコードが送信されました。",
  "please_confirm_you_are_not_a_robot": "ロボットではないことを確認してください。",
  "email_verified_successfully": "メールアドレスが正常に確認されました。",
  "continue": "続行",
  "notifications": "通知",
  "unread_notifications": "件の未読通知",
  "unread_notification": "件の未読通知",
  "unread": "未読",
  "mark_all_notifications_read": "すべて既読にする",
  "notifications_update_error": "通知を更新できませんでした。",
  "try_again": "再試行",
  "notifications_load_error": "通知を読み込めませんでした",
  "notifications_load_error_description": "接続を確認して、もう一度お試しください。",
  "notifications_empty": "通知はまだありません",
  "notifications_empty_description": "更新や重要なアクティビティがここに表示されます。",
  "notification_not_found": "通知が見つかりません",
  "notification_not_found_description": "この通知は利用できないか、アクセス権がありません。",
  "back_to_notifications": "通知一覧に戻る",
  "open_notification": "開く",
  "loading_notifications": "通知を読み込み中",
  "loading_notification": "通知を読み込み中",
  "notifications_subtitle": "更新、新しいコース、重要なアクティビティを一か所で確認できます。",
  "recent_activity": "最近のアクティビティ",
  "notifications_all_read": "すべて確認済みです",
  "staff_essentials_invites_title_required": "タイトルは必須です。",
  "staff_essentials_invites_updated": "招待を更新しました。",
  "staff_essentials_invites_created": "招待を作成しました。",
  "staff_essentials_invites_link_unavailable": "招待リンクは利用できません。",
  "staff_essentials_invites_link_copied": "招待リンクをコピーしました。",
  "staff_essentials_invites_copy_prompt": "この招待リンクをコピーしてください:",
  "staff_essentials_invites_eyebrow": "MagVenture Universe",
  "staff_essentials_invites_menu_title": "MVU Lite Invitations",
  "staff_essentials_invites_title": "MVU Lite Invitations",
  "staff_essentials_invites_subtitle": "MagVenture Universe Lite の招待リンクを作成し、各リンクで登録された人数を確認します。",
  "staff_essentials_invites_refresh": "更新",
  "staff_essentials_invites_create": "招待を作成",
  "staff_essentials_invites_total": "招待合計",
  "staff_essentials_invites_active": "有効",
  "staff_essentials_invites_registrations": "登録",
  "staff_essentials_invites_remaining": "残り",
  "staff_essentials_invites_links": "招待リンク",
  "staff_essentials_invites_found_singular": "件の招待",
  "staff_essentials_invites_found_plural": "件の招待",
  "staff_essentials_invites_none_created": "招待リンクはまだありません",
  "staff_essentials_invites_syncing": "同期中",
  "staff_essentials_invites_live_data": "ライブデータ",
  "staff_essentials_invites_loading_links": "招待リンクを読み込み中...",
  "staff_essentials_invites_column_title": "タイトル",
  "staff_essentials_invites_column_link": "リンク",
  "staff_essentials_invites_column_status": "ステータス",
  "staff_essentials_invites_column_used": "使用済み",
  "staff_essentials_invites_column_remaining": "残り",
  "staff_essentials_invites_column_expires": "期限",
  "staff_essentials_invites_column_created": "作成日",
  "staff_essentials_invites_column_actions": "操作",
  "staff_essentials_invites_active_status": "有効",
  "staff_essentials_invites_inactive_status": "無効",
  "staff_essentials_invites_unlimited": "無制限",
  "staff_essentials_invites_copy_link": "リンクをコピー",
  "staff_essentials_invites_history": "履歴",
  "staff_essentials_invites_edit": "編集",
  "staff_essentials_invites_empty_title": "Lite 招待はまだありません",
  "staff_essentials_invites_empty_description": "最初の招待リンクを作成して登録の追跡を開始します。",
  "staff_essentials_invites_edit_modal": "招待を編集",
  "staff_essentials_invites_create_modal": "招待を作成",
  "staff_essentials_invites_generated_by_strapi": "招待コードと公開リンクは Strapi によって生成されます。",
  "staff_essentials_invites_field_title": "タイトル",
  "staff_essentials_invites_field_maximum_uses": "No. of users having access to this invitation",
  "staff_essentials_invites_field_expires_at": "有効期限",
  "staff_essentials_invites_history_modal": "招待履歴",
  "staff_essentials_invites_loading_history": "履歴を読み込み中...",
  "staff_essentials_invites_no_institution": "所属機関なし",
  "staff_essentials_invites_no_registrations": "この招待にはまだ登録がありません。",
  "staff_essentials_invites_locked_content_title": "コンテンツへのアクセス",
  "lite_invite_default_content_help": "Lite に設定されたすべてのコンテンツはデフォルトで利用できます。詳細オプションでアクセスをカスタマイズできます。",
  "staff_essentials_invites_locked_content_description": "この招待で登録したユーザーは、チェックされたコンテンツを利用できます。アクセスをブロックするには、チェックを外してください。",
  "staff_essentials_invites_locked_content_selected": "アクセス可能",
  "staff_essentials_invites_locked_content_select_visible": "表示結果へのアクセスを許可",
  "staff_essentials_invites_locked_content_clear": "すべてのコンテンツをロック",
  "staff_essentials_invites_locked_content_search": "Search Lite content",
  "staff_essentials_invites_locked_content_filter": "Content type",
  "staff_essentials_invites_locked_content_all_types": "All types",
  "staff_essentials_invites_locked_content_loading": "Loading catalog...",
  "staff_essentials_invites_locked_content_empty": "No matching content.",
  "staff_essentials_invites_locked_content_error": "Could not load the Lite catalog.",
  "staff_essentials_invites_content_preset_title": "コンテンツプリセット",
  "staff_essentials_invites_content_preset_description": "1 つ以上のグループを選択すると、現在の選択がそれらのグループのコンテンツに置き換わります。その後、下の項目を個別に変更できます。",
  "staff_essentials_invites_content_preset_placeholder": "定義済みコンテンツグループ",
  "staff_essentials_invites_content_preset_custom": "カスタム選択（プリセットなし）",
  "staff_essentials_invites_content_preset_loading": "コンテンツプリセットを読み込み中...",
  "staff_essentials_invites_content_preset_error": "コンテンツプリセットを読み込めませんでした。",
  "staff_essentials_invites_content_preset_empty": "有効なプリセットはありません。コンテンツは手動で選択できます。",
  "staff_essentials_invites_content_preset_applied": "プリセットを適用しました",
  "staff_essentials_invites_content_preset_applied_description": "このコンテンツは招待にコピーされました。以下で変更しても Strapi グループは変更されません。",
  "exclusive_content_title": "Exclusive content",
  "exclusive_content_message": "This content is exclusive to MagVenture clients.",
  "survey_load_error": "このアンケートを読み込めませんでした。",
  "survey_unavailable": "アンケートを利用できません",
  "survey_back_to_course": "コースに戻る",
  "survey_thank_you": "フィードバックありがとうございます",
  "survey_completed_description": "回答を保存しました。コースを続けることができます。",
  "survey_submitted": "送信済み",
  "survey_continue_course": "コースを続ける",
  "survey_course_feedback": "コースのフィードバック",
  "survey_intro_description": "トレーニング体験について、以下の質問に回答してください。",
  "survey_questions": "問",
  "survey_minutes": "分",
  "survey_account_linked": "アカウントに保存",
  "survey_start": "アンケートを開始",
  "survey_progress": "アンケートの進捗",
  "survey_optional": "任意",
  "survey_required": "必須",
  "survey_text_placeholder": "回答を入力してください...",
  "survey_back": "戻る",
  "survey_submit": "フィードバックを送信",
  "survey_continue": "続ける",
  "survey_required_answer": "この質問は必須です。",
  "survey_required_before_quiz": "このクイズを開始する前に、必須アンケートを完了してください。",
  "survey_required_title": "アンケートが必要です",
  "survey_open": "アンケートを開く",
  "survey_completed_action": "アンケート完了",
  "survey_complete_required": "必須アンケートを完了する",
  "survey_course_completed": "コース完了",
  "survey_next_step": "次のステップ",
  "survey_share_experience": "体験を共有してください",
  "survey_opens_in": "アンケートを開くまで",
  "survey_seconds": "秒",
  "survey_answer_now": "アンケートに回答",
  "survey_stay_here": "ここに留まる",
  "user_approvals_menu_title": "ユーザー承認",
  "user_approvals_eyebrow": "アクセス管理",
  "user_approvals_title": "ユーザー承認",
  "user_approvals_subtitle": "承認範囲に割り当てられた保留中のアクセス申請を確認します。",
  "user_approvals_pending_count": "保留中",
  "user_approvals_refresh": "更新",
  "user_approvals_pending_requests": "保留中の申請",
  "user_approvals_search_placeholder": "名前、メール、会社で検索",
  "user_approvals_unavailable": "承認を利用できません",
  "user_approvals_auth_required": "承認申請を確認するにはログインしてください。",
  "user_approvals_not_authorized": "このアカウントに有効な承認受信者が関連付けられていません。",
  "user_approvals_network_error": "ネットワークエラーです。もう一度お試しください。",
  "user_approvals_load_error": "承認申請を読み込めませんでした。",
  "user_approvals_empty": "保留中の承認はありません。",
  "user_approvals_empty_description": "承認範囲に割り当てられた新しい申請がここに表示されます。",
  "user_approvals_no_search_results": "一致する承認はありません",
  "user_approvals_no_search_results_description": "別の名前、メール、会社をお試しください。",
  "user_approvals_created_at": "作成日時",
  "user_approvals_name": "名前",
  "user_approvals_email": "メール",
  "user_approvals_company": "会社",
  "user_approvals_country": "国",
  "user_approvals_region": "地域",
  "user_approvals_location": "所在地",
  "user_approvals_status": "状態",
  "user_approvals_actions": "操作",
  "user_approvals_approved": "承認済み",
  "user_approvals_rejected": "拒否済み",
  "user_approvals_approve": "承認",
  "user_approvals_reject": "拒否",
  "user_approvals_already_processed": "この承認申請はすでに処理されています。",
  "user_approvals_process_error": "この承認申請を処理できませんでした。",
  "user_approvals_approve_success": "ユーザーを承認しました。",
  "user_approvals_reject_success": "ユーザーを拒否しました。",
  "user_approvals_manual_review_required": "手動確認が必要です",
  "user_approvals_company_informed": "登録時に入力された会社",
  "user_approvals_phone": "電話",
  "user_approvals_customer_select": "顧客 / クリニック",
  "user_approvals_search_companies": "顧客またはクリニックを検索",
  "user_approvals_no_companies": "一致する顧客またはクリニックがありません",
  "user_approvals_company_load_error": "顧客またはクリニックを読み込めませんでした。",
  "user_approvals_confirm_title": "ユーザーを承認",
  "user_approvals_confirm_description": "登録内容を確認し、アクセス承認前に顧客との関連付けを確認してください。",
  "user_approvals_association_confirmation": "このユーザーの関連付け先：",
  "user_approvals_confirm_approval": "承認を確認",
  "mag.title": "Maggie",
  "mag.subtitle": "Your learning companion",
  "mag.preview_badge": "Preview",
  "mag.open_aria": "Open Maggie assistant",
  "mag.close_aria": "Close Maggie assistant",
  "mag.launcher_tooltip": "Talk to Maggie",
  "mag.intro_title": "Hi! I'm Maggie.",
  "mag.intro_body": "How can I help?",
  "mag.dismiss_intro_aria": "Dismiss Maggie introduction",
    "mag.welcome": "こんにちは！Maggieです。今日はどんなことを知りたいですか？",
    "mag.welcome_named": "こんにちは、{name}さん！Maggieです。今日はどんなことを知りたいですか？",
  "mag.quick_actions_label": "Try asking",
  "mag.quick.find_course": "Find a course",
  "mag.quick.explore_trails": "Explore Learning Paths",
  "mag.quick.continue_learning": "Continue learning",
  "mag.quick.product_tutorials": "Find product tutorials",
  "mag.quick.about_magventure": "Learn how MagVenture works",
  "mag.placeholder": "Ask Maggie a question...",
  "mag.composer_label": "Message to Maggie",
  "mag.send_aria": "Send message to Maggie",
  "mag.preview_response": "MagVenture の学習ライブラリを使って回答できます。",
  "mag.local_error": "Maggie は回答を準備できませんでした。もう一度お試しください。",
  "mag.typing": "Maggie が回答を準備しています",
  "mag.you_label": "Your message",
  "mag.mag_label": "Message from Maggie",
  "mag.avatar_fallback": "Maggie avatar fallback",
  "mag.loading": "Opening Maggie...",
    "mag.sources": "出典",
    "mag.page": "ページ",
  "mag.feedback_question": "役に立ちましたか？",
  "mag.feedback_up": "役に立った回答",
  "mag.feedback_down": "役に立たなかった回答",
  "mag.feedback_thanks": "フィードバックありがとうございます。",
  "mag.feedback_error": "フィードバックを送信できませんでした。",
    "mag.feedback_form.title": "フィードバックを共有",
    "mag.feedback_form.open": "ここをクリックしてフィードバックを共有",
    "staff_essentials_invites_content_locked": "ロック済み",
    "staff_essentials_invites_content_available": "アクセス許可済み",
    "mag.feedback_form.description": "Your feedback will be saved in our internal inbox for the MagVenture team to review. Up to 4,000 characters.",
    "mag.feedback_form.placeholder": "Your feedback",
    "mag.feedback_form.submit": "Submit feedback",
    "mag.feedback_form.cancel": "Back to chat",
    "mag.competitor_feedback.prompt": "こんにちは！Competitive Hubについてお手伝いできます。何を知りたいですか？下のフィードバックボタンからご提案も送れます。",
    "mag.competitor_feedback.prompt_named": "こんにちは、{name}さん！Competitive Hubについてお手伝いできます。何を知りたいですか？下のフィードバックボタンからご提案も送れます。",
  "mag.competitor_feedback.placeholder": "Share your Competitor Hub feedback...",
    "mag.competitor_feedback.success": "Thank you! Your feedback has been saved for our team to review.",
    "mag.competitor_feedback.error": "Your feedback could not be saved. Your message is still in the form; please try again.",
  "mag.feedback_reason.not_helpful": "役に立たない",
  "mag.feedback_reason.wrong_source": "出典が違う",
  "mag.feedback_reason.unclear": "不明確",
  "mag.feedback_reason.too_general": "一般的すぎる",
  "mag.feedback_reason.unsafe": "安全ではない",
  "competitive_intelligence_menu_title": "競合インテリジェンス",
  "competitive_intelligence_eyebrow": "市場インテリジェンス",
  "competitive_intelligence_title": "競合インテリジェンス",
  "competitive_intelligence_description": "MagVentureが追跡する競合研究、市場シグナル、ソーシャル情報源の最新概要です。",
  "competitive_intelligence_freshness_unknown": "更新時刻を取得できません",
  "competitive_intelligence_overview_heading": "インテリジェンス概要",
  "competitive_intelligence_metric_competitors": "追跡中の競合企業",
  "competitive_intelligence_metric_research": "研究レコード",
  "competitive_intelligence_metric_market": "市場シグナル",
  "competitive_intelligence_metric_social": "ソーシャル投稿",
  "competitive_intelligence_sources_title": "研究情報源",
  "competitive_intelligence_sources_description": "現在の競合インテリジェンスデータベースの対象範囲と更新状況です。",
  "competitive_intelligence_records": "件",
  "competitive_intelligence_sources_empty": "情報源ごとの詳細はまだありません。",
  "competitive_intelligence_loading": "競合インテリジェンスの概要を読み込んでいます",
  "competitive_intelligence_empty_title": "インテリジェンスデータはまだありません",
  "competitive_intelligence_empty_description": "データパイプラインはまだ概要レコードを公開していません。",
  "competitive_intelligence_denied_title": "アクセスできません",
  "competitive_intelligence_denied_description": "このアカウントには競合インテリジェンスへのアクセス権がありません。",
  "competitive_intelligence_unavailable_title": "競合インテリジェンスを利用できません",
  "competitive_intelligence_unavailable_description": "現在サービスに接続できません。しばらくしてから再試行してください。",
  "competitive_intelligence_error_title": "概要を読み込めませんでした",
  "competitive_intelligence_error_description": "予期しない応答により概要を読み込めませんでした。",
  ...competitiveIntelligenceResearchTranslations.Japanese
}
